<button nbButton *ngIf="!value.assetNumber" status="primary" size="small" (click)="openScopeSelectionDialog()">
    <nb-icon icon="plus-outline"></nb-icon>
    Add scope
</button>
<button nbButton *ngIf="value.assetNumber" status="control" size="small" (click)="openScopeSelectionDialog()">
    <nb-icon icon="edit-outline"></nb-icon>
    {{ value.assetNumber }}
</button>
